import { useMemo } from "react";
import { AgreementActivity } from "../../../api/services";
import { useRouteMatch } from "react-router-dom";

export const useAgreementActivity = (activity: AgreementActivity) => {
  const { agreementId, agreementNumber, agreementStatus } = activity;
  const { url } = useRouteMatch();

  return useMemo(
    () => ({
      title: `Agreement ${agreementNumber} ${agreementStatus.toLowerCase()}`,
      link: `${url}/agreements/${agreementId}`,
    }),
    [agreementNumber, agreementStatus, agreementId, url],
  );
};
